import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { useOutsideClickForTwoRef } from "../../../Hooks/useOutsideClickForTwoRef";
import { useDispatch } from "react-redux";
import KebabMenu from "./KebabMenu";
import {
  openOrderKebabMenu,
  resetOrderKebabOpen,
} from "../../../Features/orderManagementSlice";
import DotsVertical from "../../../Assets/OrderManagement/DotsVertical.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  formatDateToIST,
  getReturnOrderStatusUI,
} from "../../../lib/utils/utils";

const OrderListItem = ({ order }) => {
  const { orderId, createdAt, total, returnStatus } = order;
  const { title, statusClass } = getReturnOrderStatusUI(returnStatus);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const kebabRef = useRef(null);
  const kebabButtonRef = useRef(null);

  useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
    dispatch(resetOrderKebabOpen());
  });

  const kebabOrderId = useSelector(
    (state) => state.orderManagement.orderKebab.orderId
  );

  const handleOpenKebab = () => {
    dispatch(openOrderKebabMenu(orderId));
  };

  const forwardToOrderDetailsPage = () => {
    navigate(`${location.pathname}/${orderId}`);
  };

  return (
    <div className="flex items-center bg-[#FFFFFF] border-t text-[#121212] font-normal border-[#EAEAEA]">
      <button
        onClick={forwardToOrderDetailsPage}
        className="outline-none w-[calc((35/100)*(100%-44px))] px-[10px] py-[26px] hover:bg-[linear-gradient(90deg,_rgba(245,245,245,1)_0%,_rgba(255,255,255,1)_100%)]"
      >
        <h2 className="font-semibold text-[14px] leading-6 text-[#121212] text-left whitespace-nowrap overflow-hidden text-ellipsis font-ursbold capitalize">
          #{orderId?.slice(-6)}
        </h2>
      </button>
      <h2 className="w-[calc((35/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6 font-urmed">
        {formatDateToIST(createdAt)}
      </h2>
      <h2 className="w-[calc((15/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6 font-urmed">
        ₹{total}
      </h2>
      <div className="w-[calc((15/100)*(100%-44px))] px-[10px] py-[26px]">
        <span className={`px-3 py-[2px] rounded-xl text-sm ${statusClass}`}>{title}</span>
      </div>
      <div className="w-[44px] flex items-center justify-center">
        <div
          onClick={handleOpenKebab}
          ref={kebabButtonRef}
          className="relative w-full py-[26px] flex items-center justify-center outline-none cursor-pointer"
        >
          <img src={DotsVertical} alt="" />

          {kebabOrderId === orderId && (
            <KebabMenu boxRef={kebabRef} item={order} />
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderListItem;
